var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
import ExportPdfTimeCommand from '../../commands/hub/export.pdf.time.command';
import { HubCalendarActionCommand } from '../../commands/pagination.query.command';
import { BaseComponent } from '../../common/components/base.component';
import { EventTimeService } from '../../services/event.time.service';
import { ImageService } from '../../services/image.service';
import { ExportPdfModalComponent } from './export.pdf.modal/export.pdf.modal.component';
import { ExportPdfModalActions, ExportPdfModalData, PDFSettingCommand, } from './export.pdf.modal/export.pdf.modal.provider';
import { getRouteUrl, routeConfigs } from '../../common/constants/route.config';
import { AuthService } from '../../common/services/auth.service';
import { ModalService } from '../../common/services/modal.service';
import { CustomizationApiService } from '../../services/customization.api.service';
import { HubApiService } from '../../services/hub.api.service';
import { HubCalendarStore, HubCalendarEventsStore, HubCalendarPlacesStore, HubExportPdfStore, HubLogoStore, PDFSettingsStore, } from '../../stores/hub.calendar.store';
import { ExportService, PDFType } from '../../services/export.csv.service';
import { config } from '../../../config/config';
import { HubNavigatorComponent } from './side.bar/hub.side.bar.component';
import { VisitorApiService } from '../../services/visitor.api.service';
import { ConfirmModalActions, ConfirmModalData } from '../../common/components/confirm.modal/confirm.modal.provider';
import { ConfirmModalComponent } from '../../common/components/confirm.modal/confirm.modal.component';
var HubComponent = /** @class */ (function (_super) {
    __extends(HubComponent, _super);
    function HubComponent(router, authService, hubApiService, exportService, hubCalendarStore, hubCalendarEventsStore, hubCalendarPlacesStore, hubExportPdfStore, modalService, imageService, hubLogoStore, apiService, pdfSettingsStore, customizationService, activatedRoute) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.router = router;
        _this.authService = authService;
        _this.hubApiService = hubApiService;
        _this.exportService = exportService;
        _this.hubCalendarStore = hubCalendarStore;
        _this.hubCalendarEventsStore = hubCalendarEventsStore;
        _this.hubCalendarPlacesStore = hubCalendarPlacesStore;
        _this.hubExportPdfStore = hubExportPdfStore;
        _this.modalService = modalService;
        _this.imageService = imageService;
        _this.hubLogoStore = hubLogoStore;
        _this.apiService = apiService;
        _this.pdfSettingsStore = pdfSettingsStore;
        _this.customizationService = customizationService;
        _this.activatedRoute = activatedRoute;
        _this.command = new HubCalendarActionCommand();
        _this.events = Array();
        _this.places = Array();
        _this.exportFilename = config.exportFilename;
        _this.columns = config.columns;
        _this.pdfSettings = new PDFSettingCommand();
        _this.imgoingLogo = config.newDesignLogoUrl;
        _this.exportPDFMaxItemCount = 100;
        return _this;
    }
    HubComponent.prototype.ngOnInit = function () {
        var _this = this;
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        this.imgoingLogo = this.imageService.imageSourceUrl(this.imgoingLogo);
        this.hubLogoStore.logoCommand.takeUntil(this.isDestroyed).subscribe(function (logo) {
            _this.logoUrl =
                isNullOrUndefined(logo) || isNullOrUndefined(logo.isDefault) || logo.isDefault
                    ? config.defaultLogoUrl
                    : logo.url;
            _this.logo = logo;
        });
        // this.pdfSettingsStore.pdfCommand
        //     .takeUntil(this.isDestroyed)
        //     .subscribe((settings: PDFSettingCommand) => {
        //         if (settings.pdf.headerImage.event.url !== 'not-changed') {
        //             this.pdfSettings.pdf.headerImage.event = settings.pdf.headerImage.event;
        //         }
        //         if (settings.pdf.headerImage.place.url !== 'not-changed') {
        //             this.pdfSettings.pdf.headerImage.place = settings.pdf.headerImage.place;
        //         }
        //         if (settings.eventCalendarURL) {
        //             this.pdfSettings.eventCalendarURL = settings.eventCalendarURL;
        //         }
        //         if (settings.placeCalendarURL) {
        //             this.pdfSettings.placeCalendarURL = settings.placeCalendarURL;
        //         }
        //     });
        this.hubCalendarStore.actionCommand.takeUntil(this.isDestroyed).subscribe(function (command) {
            _this.command = command;
            _this.location =
                (command.queryParams.isApproved ? 'Approved' : 'Unapproved') +
                    (_this.command.isEventCalendar ? ' Events' : ' Places');
        });
        this.hubCalendarEventsStore.eventsCommand.takeUntil(this.isDestroyed).subscribe(function (events) {
            _this.events = events;
        });
        this.hubCalendarPlacesStore.placesCommand.takeUntil(this.isDestroyed).subscribe(function (places) {
            _this.places = places;
        });
        this.hubExportPdfStore.expoertPdfCommand.takeUntil(this.isDestroyed).subscribe(function (data) {
            _this.exportPdfCommand = data;
        });
    };
    //   public downloadCSV() {
    //     if (this.command.isEventCalendar) {
    //       let temp = this.events.map((x) => {
    //         return {
    //           EventTitle: x.title || x.name,
    //           EventStartTime: EventTimeService.convertByTimezoneFormatterIncludeNoTimeCheck(
    //             x.startTime,
    //             x.timezoneFormatter
    //           ),
    //           EventEndTime: EventTimeService.convertByTimezoneFormatterIncludeNoTimeCheck(x.endTime, x.timezoneFormatter),
    //           Image: this.imageService.imageSourceUrl(x.cover ? x.cover.source : null),
    //           Description: x.description,
    //           Venue: x.venue,
    //           EventAddress: x.address ? x.address.address + (x.isHybridEvent ? '(& Virtual)' : '') : '(Virtual Event)',
    //           Host: x.owner.name,
    //           TicketURI: x.ticketUri,
    //           Link: x.eventLink,
    //           HostLink: x.hostLink,
    //         };
    //       });
    //       this.exportService.exportCSV(temp, this.columns.events, this.exportFilename.events);
    //     } else {
    //       let temp = this.places.map((x) => {
    //         return {
    //           PlaceTitle: x.title,
    //           PlaceCategory: x.category,
    //           Image: x.image,
    //           Description: x.description,
    //           PlaceAddress: x.address,
    //           PlaceEmails: x.emails,
    //           PlacePhone: x.phone,
    //           PlaceWebsite: x.website,
    //           PlaceLikes: x.likes,
    //           PlaceCheckins: x.checkins,
    //           Link: x.hostLink,
    //         };
    //       });
    //       this.exportService.exportCSV(temp, this.columns.places, this.exportFilename.places);
    //     }
    //   }
    HubComponent.prototype.downloadPDF = function () {
        this.showPDFPopup();
    };
    HubComponent.prototype.navigateToSupport = function () {
        window.open('https://itidigital.freshdesk.com/support/home', '_blank');
    };
    HubComponent.prototype.goEditAccount = function () {
        this.router.navigateByUrl(getRouteUrl(routeConfigs.hub.editAccount, {
            hubName: this.hubName,
        }));
    };
    HubComponent.prototype.logout = function () {
        this.authService.logout();
        this.router.navigateByUrl(getRouteUrl(routeConfigs.auth.login));
    };
    HubComponent.prototype.recordExportTime = function (itemExportCount) {
        if (config.isAnalyticsOn) {
            this.hubApiService
                .recordExportPdfTime(this.hubName, new ExportPdfTimeCommand(this.hubName, this.exportPdfCommand.isEvent ? 'event' : 'place', this.exportPdfCommand.isEvent ? this.exportPdfCommand.eventSource : this.exportPdfCommand.placeSource, this.exportPdfCommand.from, this.exportPdfCommand.to, this.exportPdfCommand.isPrintVersion ? 'print' : 'online', this.exportPdfCommand.category, itemExportCount))
                .subscribe(function (x) { });
        }
    };
    HubComponent.prototype.exportCSV = function (items) {
        var _this = this;
        if (this.exportPdfCommand.isEvent) {
            var temp = items.map(function (x) {
                return {
                    Title: x.title || x.name,
                    StartTime: EventTimeService.convertByTimezoneFormatterIncludeNoTimeCheck(x.startTime, x.timezoneFormatter),
                    EndTime: EventTimeService.convertByTimezoneFormatterIncludeNoTimeCheck(x.endTime, x.timezoneFormatter),
                    StartTimeISO: x.startTime,
                    EndTimeISO: x.endTime,
                    Image: _this.imageService.imageSourceUrl(x.cover ? x.cover.source : null),
                    Description: x.description,
                    Venue: x.venue,
                    Address: x.address ? x.address.address + (x.isHybridEvent ? '(& Virtual)' : '') : '(Virtual Event)',
                    Organizer: x.owner.name,
                    TicketURI: x.ticketUri,
                    Link: x.eventLink,
                    OrganizerLink: x.hostLink,
                };
            });
            this.exportService.exportCSV(temp, this.columns.events, this.exportFilename.events);
        }
        else {
            var temp = items.map(function (x) {
                return {
                    Title: x.title,
                    Category: x.category,
                    Image: _this.imageService.imageSourceUrl(x.cover ? x.cover.source : null),
                    Description: x.description,
                    Address: x.address.address || x.address,
                    Email: x.emails,
                    Phone: x.phone,
                    Website: x.website,
                    Rating: x.rating,
                    PriceRange: x.priceRange,
                    Link: x.hostLink,
                    GooglePlaceId: x.id,
                    ApprovalStatus: x.isApproved ? 'Approved' : 'Unapproved',
                };
            });
            this.exportService.exportCSV(temp, this.columns.places, this.exportFilename.places);
        }
    };
    HubComponent.prototype.showPDFPopup = function () {
        var _this = this;
        var actions = {
            confirm: function (event, progressCallback) {
                var itemExportCount = 0;
                _this.customizationService.getStyleAndPDFSettingsForHub(_this.hubName).subscribe(function (settings) {
                    if (_this.exportPdfCommand.isEvent) {
                        _this.hubApiService.getEvents(_this.hubName, _this.exportPdfCommand).subscribe(function (data) {
                            if (_this.exportPdfCommand.exportType === 'CSV') {
                                _this.exportCSV(data);
                                event.complete();
                                return;
                            }
                            var exportEventPDF = function (logoBase64) {
                                _this.exportService.exportPDF(data, PDFType.event, _this.exportPdfCommand.isPrintVersion, settings.pdf.headerImage.event.isDefault ? null : settings.pdf.headerImage.event.url[0], isNullOrUndefined(settings.logo.isDefault) || settings.logo.isDefault ? null : logoBase64, settings.eventCalendarURL, settings.placeCalendarURL, settings.moreToursURL, _this.exportPdfCommand.from, _this.exportPdfCommand.to, '', settings.style.eventButton.backgroundColor, event, function (progress) {
                                    if (progressCallback) {
                                        progressCallback(progress + '%');
                                    }
                                });
                            };
                            var loadLogoAndExport = function () {
                                if (_this.logoUrl) {
                                    // images from Amazon S3 has CORS problems (have already set in the Amazon dashboard, but still not work), so here is to get the image base64 from server side
                                    if (_this.logoUrl.includes('s3.amazonaws.com')) {
                                        _this.apiService.getImageBase64(_this.logoUrl).subscribe(function (base64Data) {
                                            var base64;
                                            if (base64Data && base64Data.succeed) {
                                                base64 = base64Data.base64;
                                            }
                                            else {
                                                console.error('logo base64 not get');
                                                return;
                                            }
                                            exportEventPDF(base64);
                                        });
                                    }
                                    else {
                                        // images from ImGoing server, get base64 locally
                                        _this.imageService.geetBase64ImageByUrl(_this.logoUrl).then(function (base64) {
                                            exportEventPDF(base64);
                                        });
                                    }
                                }
                                else {
                                    exportEventPDF(null);
                                }
                            };
                            if (data.length > _this.exportPDFMaxItemCount &&
                                !_this.exportPdfCommand.from &&
                                !_this.exportPdfCommand.to &&
                                !_this.exportPdfCommand.isToBeExport &&
                                !_this.exportPdfCommand.choice) {
                                var msg = "Exporting all events at once may result in slow loading or freezing due to the large data volume. For a faster, smoother experience, we recommend using filters to export events in smaller, manageable groups. Thank you for your understanding!";
                                var actions_1 = {
                                    confirm: function (feed) {
                                        // data = data.slice(0, this.exportPDFMaxItemCount);
                                        loadLogoAndExport();
                                    },
                                    cancel: function (feed) {
                                        event.immediateComplete();
                                    },
                                };
                                var modalData = {
                                    confirmModalIcon: 'info',
                                    confirmModalTitle: 'Alert',
                                    confirmModalDescription: msg,
                                    confirmModalConfirmButtonText: 'Export',
                                    confirmModalCancelButtonText: 'Cancel',
                                    // confirmCheckboxDescription: `You’re exporting a large number of events. To prevent issues, only the first ${this.exportPDFMaxItemCount} events will be exported.`,
                                    isAsync: false,
                                };
                                _this.modalService.show({
                                    component: ConfirmModalComponent,
                                    providers: [
                                        { provide: ConfirmModalActions, useValue: actions_1 },
                                        { provide: ConfirmModalData, useValue: modalData },
                                    ],
                                });
                                return;
                            }
                            loadLogoAndExport();
                            _this.recordExportTime(itemExportCount);
                        });
                    }
                    else {
                        _this.exportPdfCommand.source = settings.dataSource.place || 'facebook';
                        // Google place images need to get their real url, otherwise they cannot get the base64 format data
                        _this.exportPdfCommand.convertImgUrl = _this.exportPdfCommand.source === 'google';
                        _this.hubApiService.getPlaces(_this.hubName, _this.exportPdfCommand).subscribe(function (data) {
                            if (_this.exportPdfCommand.exportType === 'CSV') {
                                _this.exportCSV(data);
                                event.complete();
                                return;
                            }
                            var placeCalendarURL = settings.placeCalendarURL;
                            if (_this.exportPdfCommand.category_id && settings.placeURLs && settings.placeURLs.length > 0) {
                                var placeURL = settings.placeURLs.find(function (x) { return x.igURL.indexOf(_this.exportPdfCommand.category_id) > -1; });
                                if (placeURL) {
                                    placeCalendarURL = placeURL.clientURL;
                                }
                            }
                            var exportPlacePDF = function (logoBase64) {
                                _this.exportService.exportPDF(data, PDFType.place, _this.exportPdfCommand.isPrintVersion, settings.pdf.headerImage.place.isDefault ? null : settings.pdf.headerImage.place.url[0], isNullOrUndefined(settings.logo.isDefault) || settings.logo.isDefault ? null : logoBase64, settings.eventCalendarURL, placeCalendarURL, settings.moreToursURL, null, null, _this.exportPdfCommand.subTitle, settings.style.eventButton.backgroundColor, event, function (progress) {
                                    if (progressCallback) {
                                        progressCallback(progress + '%');
                                    }
                                });
                            };
                            var loadLogoAndExport = function () {
                                if (_this.logoUrl) {
                                    // images from Amazon S3 has CORS problems (have already set in the Amazon dashboard, but still not work), so here is to get the image base64 from server side
                                    if (_this.logoUrl.includes('s3.amazonaws.com')) {
                                        _this.apiService.getImageBase64(_this.logoUrl).subscribe(function (base64Data) {
                                            var base64;
                                            if (base64Data && base64Data.succeed) {
                                                base64 = base64Data.base64;
                                            }
                                            else {
                                                console.error('logo base64 not get');
                                                return;
                                            }
                                            exportPlacePDF(base64);
                                        });
                                    }
                                    else {
                                        // images from ImGoing server, get base64 locally
                                        _this.imageService.geetBase64ImageByUrl(_this.logoUrl).then(function (base64) {
                                            exportPlacePDF(base64);
                                        });
                                    }
                                }
                                else {
                                    exportPlacePDF(null);
                                }
                            };
                            if (data.length > _this.exportPDFMaxItemCount &&
                                !_this.exportPdfCommand.category_id &&
                                !_this.exportPdfCommand.isToBeExport &&
                                !_this.exportPdfCommand.choice) {
                                var msg = "Exporting all places at once may result in slow loading or freezing due to the large data volume. For a faster, smoother experience, we recommend using category filters to export places in smaller, manageable groups. Thank you for your understanding!";
                                var actions_2 = {
                                    confirm: function (feed) {
                                        // data = data.slice(0, this.exportPDFMaxItemCount);
                                        loadLogoAndExport();
                                    },
                                    cancel: function (feed) {
                                        event.immediateComplete();
                                    },
                                };
                                var modalData = {
                                    confirmModalIcon: 'info',
                                    confirmModalTitle: 'Alert',
                                    confirmModalDescription: msg,
                                    confirmModalConfirmButtonText: 'Export',
                                    confirmModalCancelButtonText: 'Cancel',
                                    // confirmCheckboxDescription: `You’re exporting a large number of places. To prevent issues, only the first ${this.exportPDFMaxItemCount} places will be exported.`,
                                    isAsync: false,
                                };
                                _this.modalService.show({
                                    component: ConfirmModalComponent,
                                    providers: [
                                        { provide: ConfirmModalActions, useValue: actions_2 },
                                        { provide: ConfirmModalData, useValue: modalData },
                                    ],
                                });
                                return;
                            }
                            loadLogoAndExport();
                            _this.recordExportTime(itemExportCount);
                        });
                    }
                });
            },
        };
        var data = {
            isAsync: true,
        };
        this.modalService.show({
            component: ExportPdfModalComponent,
            providers: [
                { provide: ExportPdfModalActions, useValue: actions },
                { provide: ExportPdfModalData, useValue: data },
            ],
        });
    };
    return HubComponent;
}(BaseComponent));
export { HubComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/hub.component.ts.pre-build-optimizer.js